import { initializeApp } from "firebase/app";
import { initializeFirestore } from "firebase/firestore";
import config from "../../firebase-applet-config.json";

const firebaseApp = initializeApp(config);
const databaseId = (config as any).firestoreDatabaseId || "(default)";

export const db = initializeFirestore(firebaseApp, {
  experimentalForceLongPolling: true,
}, databaseId);

